import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 13a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M7 4l-2.75 2","key":"svg-1"}],["path",{"d":"M17 4l2.75 2","key":"svg-2"}],["path",{"d":"M10 13h4","key":"svg-3"}]]

const IconAlarmMinus = createReactComponent('outline', 'alarm-minus', 'AlarmMinus', __iconNode);

export default IconAlarmMinus;